import { Injector } from "@angular/core";
import moment from 'moment';
import { KpiService } from "../../../../dashboardCommon/services/kpiService";
import { DateRange } from "./dateRange";

export class Range {
    public begin: string;
    public end: string;

    constructor(begin: string, end: string) {
        this.begin = begin;
        this.end = end;
    }
}

export abstract class ContractsDirectKpiService<T> extends KpiService<T> {
    constructor(injector: Injector) {
        super(injector);
    }

    protected getDateRange(range: DateRange): Range {
        switch (range) {
            case DateRange.Past: return this.getExpiredDates();
            case DateRange.Inmediate: return this.getDayDates();
            case DateRange.Forecast: return this.getWeekDates();
            case DateRange.TodayTomorrow: return this.getTodayTomorrow();
            default: throw new Error("Invalid date range");
        }
    }

    private getExpiredDates(): Range {
        let end = moment().subtract(1, 'day');
        let begin = moment(end).subtract(15, 'day');
        return new Range(
            "{0}{1}{2}".format(String(begin.year()).padStart(4, "0"), String(begin.month() + 1).padStart(2, "0"), String(begin.date()).padStart(2, "0")),
            "{0}{1}{2}".format(String(end.year()).padStart(4, "0"), String(end.month() + 1).padStart(2, "0"), String(end.date()).padStart(2, "0"))
        );
    }

    private getDayDates(): Range {
        let begin = moment();
        let daysAhead = 1;
        switch (begin.isoWeekday()) {
            case 5: { daysAhead = 3; break; }
            case 6: { daysAhead = 2; break; }
            default: { daysAhead = 1; break; }
        }
        let end = moment(begin).add(0,'day');

        return new Range(
            "{0}{1}{2}".format(String(begin.year()).padStart(4, "0"), String(begin.month() + 1).padStart(2, "0"), String(begin.date()).padStart(2, "0")),
            "{0}{1}{2}".format(String(end.year()).padStart(4, "0"), String(end.month() + 1).padStart(2, "0"), String(end.date()).padStart(2, "0"))
        );
    }

    private getWeekDates(): Range {
        let begin = moment();
        let end = moment(begin).add(6, 'day');

        return new Range(
            "{0}{1}{2}".format(String(begin.year()).padStart(4, "0"), String(begin.month() + 1).padStart(2, "0"), String(begin.date()).padStart(2, "0")),
            "{0}{1}{2}".format(String(end.year()).padStart(4, "0"), String(end.month() + 1).padStart(2, "0"), String(end.date()).padStart(2, "0"))
        );
    }
    private getTodayTomorrow(): Range {
        let begin = moment();
        let daysAhead = 1;
        switch (begin.isoWeekday()) {
            case 5: { daysAhead = 3; break; }
            case 6: { daysAhead = 2; break; }
            default: { daysAhead = 1; break; }
        }
        let end = moment(begin).add(daysAhead, 'day');

        return new Range(
            "{0}{1}{2}".format(String(begin.year()).padStart(4, "0"), String(begin.month() + 1).padStart(2, "0"), String(begin.date()).padStart(2, "0")),
            "{0}{1}{2}".format(String(end.year()).padStart(4, "0"), String(end.month() + 1).padStart(2, "0"), String(end.date()).padStart(2, "0"))
        );
    }
}
